import { formatLocalDate, formatLocalDateTimeHourAndMinutes, getDatePortion, getNow } from 'model';
import { DateTime } from 'luxon';
import React from 'react';

export type TimeFormat = 'relative' | 'date' | 'time' | 'dateTime';

export type TimeProps = {
	time: string;
	testId?: string;
};

function isToday(time: string): boolean {
	return getDatePortion(getNow()) === getDatePortion(DateTime.fromISO(time).toISO());
}

function formatTime(time: string): string {
	return isToday(time)
		? formatLocalDateTimeHourAndMinutes(time)
		: `${formatLocalDate(time)} ${formatLocalDateTimeHourAndMinutes(time)}`;
}
export const MessageTime: React.FC<TimeProps> = ({ time, testId }: TimeProps) => {
	return (
		<time data-testid={testId} dateTime={time}>
			{formatTime(time)}
		</time>
	);
};
